'use client'

import { useState, useEffect } from 'react'
import Link from 'next/link'
import Image from 'next/image'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone, faEnvelope, faMessagesQuestion } from '@awesome.me/kit-94e593bf23/icons/classic/regular'

import ObfuscatedEmail from '@/app/_components/ObfuscatedEmail'
import ChatLink from '@/app/_components/ChatLink'

const imagePairs = [
    { img1: '/images/assistance-block/assistance-a-1.jpg', img2: '/images/assistance-block/assistance-a-2.jpg' },
    { img1: '/images/assistance-block/assistance-b-1.jpg', img2: '/images/assistance-block/assistance-b-2.jpg' },
    { img1: '/images/assistance-block/assistance-c-1.jpg', img2: '/images/assistance-block/assistance-c-2.jpg' },
    { img1: '/images/assistance-block/assistance-d-1.jpg', img2: '/images/assistance-block/assistance-d-2.jpg' },
    { img1: '/images/assistance-block/assistance-e-1.jpg', img2: '/images/assistance-block/assistance-e-2.jpg' },
]

const AssistanceBlockContent = ({ emailObfuscated }) => {
    const [images, setImages] = useState(null)

    useEffect(() => {
        const randomIndex = Math.floor(Math.random() * imagePairs.length)
        setImages(imagePairs[randomIndex])
    }, [])

    return (
        <div className="flex flex-col md:flex-row">
            {/* Left half - Need Assistance */}
            <div className="flex w-full md:w-1/2">
                <div className="flex flex-col justify-start md:justify-between gap-4 flex-1 pl-[var(--site-padding)] pr-5 py-8 bg-light">
                    <div>
                        <span className="block text-3xs tracking-wider text-primary uppercase font-medium mb-1">Need Assistance?</span>
                        <div className="text-white text-xl">We Are Happy To Help</div>
                    </div>
                    <div className="flex items-start">
                        <FontAwesomeIcon icon={faMessagesQuestion} className="text-sm me-2 mt-1 text-white" />
                        <ChatLink className="text-sm text-white hover:text-primary transition-colors">
                            Open the <span className="font-medium">help center</span>
                        </ChatLink>
                    </div>
                    <div className="flex items-start">
                        <FontAwesomeIcon icon={faEnvelope} className="text-sm me-2 mt-1 text-white" />
                        <span className="text-sm text-white">Email <ObfuscatedEmail obfuscated={emailObfuscated} className="font-medium text-white hover:text-primary" /> and we will respond promptly.</span>
                    </div>
                    <div className="flex items-start">
                        <FontAwesomeIcon icon={faPhone} className="text-sm me-2 mt-1 text-white" />
                        <span className="text-sm text-white">Call <a href="tel:18666634483" className="font-medium hover:text-primary">1.866.663.4483</a> to speak to a member of our knowledgeable staff.</span>
                    </div>
                </div>
                <div className="hidden xl:block relative w-1/3 shrink-0">
                    {images && (
                        <Image
                            className="object-cover"
                            src={images.img1}
                            alt="Need Assistance?"
                            fill
                            sizes="(max-width: 1279px) 0px, 16.67vw"
                        />
                    )}
                </div>
            </div>

            {/* Right half - Trade Program */}
            <div className="flex w-full md:w-1/2">
                <div className="flex flex-col justify-between flex-1 px-5 py-8 bg-gray-5">
                    <div className="mb-4">
                        <span className="block text-3xs tracking-wider text-primary uppercase font-medium mb-1">Design Professional?</span>
                        <div className="text-xl">Join the hive Trade Program</div>
                    </div>
                    <p className="mb-4 text-xs">
                        For more than two decades, hive has been a trusted partner to architects and interior designers who refuse to compromise on quality. We offer expert consultation, project quotes, and dedicated support by phone and email — alongside online trade pricing for immediate access to your member benefits.
                    </p>
                    <Link href="/hive-trade-program" className="text-ink-muted text-2xs hover:text-primary underline">Join the Trade Professionals Program</Link>
                </div>
                <div className="hidden xl:block relative w-1/3 shrink-0">
                    {images && (
                        <Image
                            className="object-cover"
                            src={images.img2}
                            alt="Join the hive Trade Program"
                            fill
                            sizes="(max-width: 1279px) 0px, 16.67vw"
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

export default AssistanceBlockContent
